import axios from "axios";
import { saveAs } from "file-saver";

export const downloadEmployeeData = async ({
  selectedCompanyId,
  employeeInformationId,
  hasViewPerGroupPermission,
  hasViewAllManagedPermission,
  accessToken,
}) => {
  let apiUrl = "";

  if (hasViewPerGroupPermission) {
    if (selectedCompanyId) {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/BulkDataDownload?company_id=${selectedCompanyId}`;
    } else {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/BulkDataDownload`;
    }
  } else if (hasViewAllManagedPermission) {
    apiUrl = `${process.env.REACT_APP_BASE_URL}/BulkDataDownload?employee_id=${employeeInformationId}`;
  } else {
    throw new Error("NO_PERMISSION");
  }

  const response = await axios.get(apiUrl, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "employee_data.xlsx");
};